import { makeStyles } from "@material-ui/core/styles";

const zoneToGainEditorStyles = makeStyles(() => ({
	editor: {
		position: "relative",
		width: "100%",
		paddingTop: 48
	},
	ruler: {
		marginBottom: 0
	},
	// The target slider sits directly over the spots slider's track. Its rail is
	// click-through so the grey spot thumbs stay draggable; only the red target
	// thumb captures pointer input.
	targetOverlay: {
		position: "absolute",
		left: 0,
		right: 0,
		bottom: 0,
		pointerEvents: "none"
	},
	targetSlider: {
		pointerEvents: "none",
		"& .MuiSlider-thumb": {
			pointerEvents: "auto"
		},
		"& .MuiSlider-markLabel": {
			display: "none"
		}
	}
}));

export default zoneToGainEditorStyles;
